import React from 'react';
import { MonkeyOopsTemplate } from '../ChatbotLimitModal/ChatbotLimitModal';
import { ModalInstanceProps } from '../interfaces';

export const AdminAccessRequiredModal = (props: ModalInstanceProps) => {
  const { closeModal } = props;
  return (
    <MonkeyOopsTemplate
      title="Admin access needed"
      bodyText="Only company owners and admins can connect a Facebook account."
      closeButtonText="Close"
      onClose={closeModal}
    />
  );
};
